import {Record} from 'immutable';

export default class CoachingMeetingCategory extends Record({
  id: 0,
  name: '',
  color: '',
  isDefault: false,
  hidden: false,
}) {
  readonly id: number;
  readonly name: string;
  readonly color: string;
  readonly isDefault: boolean;
  readonly hidden: boolean;
}
